<div class="terms-of-service">
  <ul>
    <li>
      <input type="checkbox" id="acceptTerms1" name="acceptTerms1" [checked]="acceptTerm1"
        (change)="acceptTerm1 = !acceptTerm1; emitAcceptedTerms()">
      <label for="acceptTerms1" [innerHTML]="'modeso_payment_checkout-terms_accept-terms-text1' | injectedText | async">
      </label>
    </li>
    <li>
      <input type="checkbox" id="acceptTerms2" name="acceptTerms2" [checked]="acceptTerm2"
        (change)="acceptTerm2 = !acceptTerm2; emitAcceptedTerms()">
      <label for="acceptTerms2" [innerHTML]="'modeso_payment_checkout-terms_accept-terms-text2' | injectedText | async">
      </label>
    </li>
    <li>
      <input type="checkbox" id="acceptTerms3" name="acceptTerms3" [checked]="acceptTerm3"
        (change)="acceptTerm3 = !acceptTerm3; emitAcceptedTerms()">
      <label for="acceptTerms3" [innerHTML]="'modeso_payment_checkout-terms_accept-terms-text3' | injectedText | async">
      </label>
    </li>
  </ul>
</div>
